import * as React from 'react';
import { Team } from '../../../sdk/model';
import { Button, IconButton, Avatar, SxProps, Theme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { teamApi } from '../../../adapters/APIExporter'

type SizeVariant = 'normal' | 'large' | 'xlarge';

interface TeamDisplayProps {
  leagueId: string | undefined;
  team: Team | undefined;
  emphasized: boolean;
  size?: SizeVariant;
  sx?: SxProps<Theme>;
  teamId: string | undefined;
}

const sizeMap = {
  normal: { avatar: 40, spacing: 1 },
  large: { avatar: 56, spacing: 1.5 },
  xlarge: { avatar: 64, spacing: 2 },
} as const;

function TeamDisplay({ 
  leagueId, 
  team, 
  emphasized, 
  size = 'normal',
  sx = {},
  teamId = undefined,
}: TeamDisplayProps) {
  const navigate = useNavigate();
  const [teamInState, setTeamInState] = React.useState(team);
  const { avatar: avatarSize, spacing } = sizeMap[size] || sizeMap.normal;
  React.useEffect(() => {
    setTeamInState(team);
  }, [team]);
  if (!teamInState) {
    if (teamId) {
      teamApi.getTeam(teamId).then(response => setTeamInState(response.data));
    }
    return "DELETED TEAM"
  }
  return (
    <Button 
      onClick={() => navigate('/league/' + leagueId + '/team/' + teamInState.id)}
      sx={[{
        textTransform: 'none',
        fontSize: size === 'large' ? '1.1rem' : size === 'xlarge' ? '1.25rem' : '1rem',
        py: 1
      }, ...(Array.isArray(sx) ? sx : [sx])]}
      disabled={!team}
    >
      <IconButton sx={{ p: 0, mr: spacing }}>
        <Avatar 
          alt={teamInState?.name} 
          src={teamInState?.picture}
          sx={{ 
            width: avatarSize, 
            height: avatarSize,
            fontSize: size === 'large' ? '1.5rem' : size === 'xlarge' ? '1.75rem' : '1.25rem'
          }}
        >
          {!teamInState?.picture && teamInState?.name?.substring(0, 1)}
        </Avatar>
      </IconButton>
      {emphasized ? <b>{teamInState?.name}</b> : teamInState?.name}
    </Button>
  );
}

export default TeamDisplay;
